import { render, staticRenderFns } from "./GooPagination3.vue?vue&type=template&id=eaacb5e0&scoped=true&lang=pug&"
import script from "./GooPagination3.vue?vue&type=script&lang=js&"
export * from "./GooPagination3.vue?vue&type=script&lang=js&"
import style0 from "./GooPagination3.vue?vue&type=style&index=0&id=eaacb5e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaacb5e0",
  null
  
)

export default component.exports